// scroll-restoration.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollRestorationService {
  private positions = new Map<string, number>();
  private routesToRestore = new Set<string>();

  save(url: string, scrollY: number) {
    this.positions.set(url, scrollY);
  }

  markForRestore(url: string) {
    this.routesToRestore.add(url);
  }

  restoreIfNeeded(url: string) {
    setTimeout(() => {
      if (!this.routesToRestore.has(url)) return;

      const saved = this.positions.get(url);
      if (saved == null) return;

      console.log('restored', saved);

      this.routesToRestore.delete(url);
      this.restoreWithRetry(saved);
    });
  }

  private restoreWithRetry(targetY: number, maxTries = 15, delay = 50) {
    let tries = 0;
    const attempt = () => {
      const container = this.getContent();
      console.log(container);
      if (!container) return;

      const maxScroll = container.scrollHeight - container.clientHeight;

      // Página já com altura suficiente OU estourou tentativas
      if (maxScroll >= targetY || tries >= maxTries) {
        container.scrollTo({ top: targetY, behavior: 'auto' });
        return;
      }

      tries++;
      setTimeout(attempt, delay);
    };

    attempt();
  }


  getContent(): HTMLElement {
    if (window.innerWidth > 1199) {
      if (document.getElementsByClassName('app-sidenav-content')) {
        const container = document.getElementsByClassName('app-sidenav-content')[0];
        return container as HTMLElement;
      }
    }
    return document.getElementById('main-content');
  }
}
